export default __webpack_public_path__ + "static/media/blackShirt.62d45896.png";